import { Col, Row, Text } from 'components';
import { SignUp } from 'screens/Website';
import styled from 'styled-components';

const AthleteImg = styled.img`
  width: 377px;
  margin: 30px 0 0;

  @media (max-width: 1024px) {
    margin: 15px 0 0 24px;
    width: 237px;
  }
`;

const SignUpContainer = styled.div`
  margin: 68px 0 0 5px;

  button {
    width: 178px;
  }
`;

const SliderElement = ({ title, content, image }) => {
  return (
    <Row>
      <AthleteImg src={image || require('assets/images/tennis-phone-tilted.png')} />

      <Col marg="98px 0 0 35px">
        <Text size="42px" med>
          {title}
        </Text>

        <Text size="28px" marg="5px 0 0">
          {content}
        </Text>

        <SignUpContainer>
          <SignUp />
        </SignUpContainer>
      </Col>
    </Row>
  );
};

export default SliderElement;
